import { useContext } from 'react';

import { IIwiAffiliationFormContext, IwiAffiliationFormContext } from '../components/IwiAffiliationFormContext';

export const useIwiAffiliationFormContext = () =>
  useContext<IIwiAffiliationFormContext | null>(IwiAffiliationFormContext) as IIwiAffiliationFormContext;
